import React, { useState, useEffect } from 'react';
import { web } from '../../helpers/api';
import { ENDPOINT } from '../../helpers/Constants';
import moment from 'moment';
import { Calendar } from '@nivo/calendar';
import { Modal, Button } from 'react-bootstrap';
import { IsMedico } from '../../utils';
function AderenzaTerapia(props) {
    const [data, setData] = useState([]);
    const [anno, setAnno] = useState(moment());  // stato per l'anno
    const [showmodal, setShowmodal] = useState(false);  // Stato per la modale
    const [selectedData, setSelectedData] = useState(null);  // Stato per i dati selezionati

    useEffect(() => {
        // Funzione per ottenere i dati dell'aderenza quando l'anno cambia
        fetchAderenza();
    }, [anno, props.key]);  // Effettua il fetch ogni volta che l'anno cambia

    const fetchAderenza = async () => {
        let id = window.location.pathname.split('/').pop();
        id = parseInt(id);
        await web.post(ENDPOINT.GETALLADERENZA, id)
            .then((response) => {
                if (response.status === 200 && response.data.dati != null) {
                    const nuovaLista = [];
                    response.data.dati.forEach(elemento => {
                        const value = elemento.risposta === "Si" ? 2 : 1;
                        const dataFormattata = moment(elemento.dataInvio).format('YYYY-MM-DD');
                        nuovaLista.push({
                            value: value,
                            day: dataFormattata
                        });
                    });
                    setData(nuovaLista);
                }
            }).catch((error) => {
                console.error("Error fetching data", error);
            });
    };

    // Funzione per incrementare l'anno di 1
    const incrementaAnno = () => {
        setAnno(prevAnno => {
            const nuovoAnno = prevAnno.clone().add(1, 'year');
            return nuovoAnno;
        });
    };

    // Funzione per diminuire l'anno di 1
    const decrementaAnno = () => {
        setAnno(prevAnno => {
            const nuovoAnno = prevAnno.clone().add(-1, 'year');
            return nuovoAnno;
        });
    };

    // Funzione per gestire il click su un giorno
    const handleDayClick = async (dayData) => {
        if (!IsMedico()) {


            const selectedDay = moment(dayData.day);
            let id = window.location.pathname.split('/').pop();
            id = parseInt(id);

            const valoreModificato = dayData.value === 1 ? 1 : dayData.value === 2 ? 2 : 0;

            // Impostiamo i dati selezionati per la modale
            setSelectedData({
                idPaziente: id,
                value: valoreModificato,
                dataInvio: selectedDay
            });

            // Mostriamo la modale
            setShowmodal(true);
        }
    };

    const handleConfirmUpdate = async () => {
        if (selectedData) {
            await web.post(ENDPOINT.UPDATEADERENZA, selectedData)
                .then((response) => {
                    if (response.status === 200) {
                        fetchAderenza();
                    }
                }).catch((error) => {
                    console.error("Error updating data", error);
                });
        }
        setShowmodal(false);

    };

    const handleClose = () => {
        setShowmodal(false);  // Chiudiamo la modale senza inviare
    };

    const isCurrentYear = anno.isSame(moment(), 'year');

    return (
        <div className="container" style={{ position: 'absolute' }}>
            <h2 className="text-center">Aderenza Terapia</h2>
            <Calendar
                key={anno.format('YYYY')}  // Forza il re-render del Calendar quando l'anno cambia
                data={data}
                from={anno.format('YYYY')}
                to={anno.format('YYYY')}
                width={800}
                height={200}
                emptyColor="#EDEDED"
                colors={['#f88064', '#f88064', '#849474', '#849474']}
                minValue={1}
                maxValue={2}
                margin={{ top: 40, right: 40, bottom: 50, left: 40 }}
                yearSpacing={5}
                monthSpacing={5}
                monthBorderColor="#ffffff"
                daySpacing={3}
                dayBorderWidth={2}
                dayBorderColor="#d9d9d9"
                legends={[{
                    anchor: 'bottom-right',
                    direction: 'row',
                    translateY: 36,
                    itemCount: 4,
                    itemWidth: 42,
                    itemHeight: 36,
                    itemsSpacing: 14,
                    itemDirection: 'right-to-left'
                }]}
                onClick={handleDayClick}  // Aggiungi il click handler
            />
            <div>
                <p>Legenda</p>
            <p><div width="60px" height="40px" style={{display:'inline-block', backgroundColor:'rgb(132, 148, 116)', minWidth:'60px'}}>&nbsp;</div>&nbsp;Verde =  2 assunzioni della terapia</p>
            <p><div width="60px" height="40px" style={{display:'inline-block', backgroundColor:'rgb(248, 128, 100)', minWidth:'60px'}}>&nbsp;</div>&nbsp;Arancione = 1 assunzione della terapia</p>
            <p><div width="60px" height="40px" style={{display:'inline-block', backgroundColor:'rgb(217, 217, 217)', minWidth:'60px'}}>&nbsp;</div>&nbsp;Grigio = nessuna assunzione della terapia</p>
            </div>
            <ul className="pagination justify-content-center">
                <li className="page-item">
                    <p className="page-link prev" onClick={decrementaAnno}>Previous</p>
                </li>
                <li className="page-item">
                    <p
                        className={`page-link next ${isCurrentYear ? 'disabled' : ''}`}
                        onClick={isCurrentYear ? null : incrementaAnno}
                    >
                        Next
                    </p>
                </li>
            </ul>

            {/* Modal per la conferma della modifica */}
            <Modal show={showmodal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{'Modifica Aderenza '}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {`Modificare aderenza? Valore modificato in: ${selectedData ? selectedData.value === 0 ? 'Una risposta' : selectedData.value === 1 ? 'Due risposte' : 'Nessuna risposta' : ''}`}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleConfirmUpdate}>
                        {'Modifica'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default AderenzaTerapia;
